import { tokenStorage } from "@/domain/auth/token-storage";

const PREFIX = "[MENU_DIAG]";

/** Temporary investigation logging — remove after menu load regression is resolved. */
export function logMenuDiag(
  event: string,
  payload?: Record<string, unknown>
): void {
  // eslint-disable-next-line no-console -- temporary QA diagnostics
  console.info(PREFIX, event, { ts: Date.now(), ...payload });
}

export function logAuthTokenDiag(context?: string): void {
  const token = tokenStorage.getAccessToken();
  logMenuDiag("auth_token", {
    context,
    hasToken: Boolean(token),
    tokenLength: token?.length ?? 0,
    tokenPreview: token ? `${token.slice(0, 8)}…${token.slice(-4)}` : null,
  });
}
